import React, { Component } from 'react';
import { Icon, Tooltip } from '@material-ui/core';
import './ConfirmIcon.scss';
import { COLORMAP } from '../styles';

class ConfirmIcon extends Component {
  state = { confirmState: false };

  handleConfirm() {
    this.setState({ confirmState: false });
    this.props.onConfirm();
  }

  handleIconClick() {
    const { disabled } = this.props;
    if (!disabled) {
      this.setState({ confirmState: true });
    }
  }

  renderTooltipText(text) {
    return (
      <div style={{ maxWidth: 184 }}>
        <div style={{ fontSize: 12, fontFamily: "Montserrat" }}>
          {text}
        </div>
      </div>
    );
  }

  renderIcon() {
    const { tooltip, icon, disabled, disabledTooltip } = this.props;
    const iconTooltip = disabled ? disabledTooltip : tooltip;

    if (this.state.confirmState) {
      return (
        <div className="icon-container">
          <Tooltip placement="top" title={this.renderTooltipText('Cancel')} onClick={() => this.setState({ confirmState: false })}>
            <Icon style={{ marginRight: 5, color: COLORMAP.pink }}>close</Icon>
          </Tooltip>
          <Tooltip placement="top" title={this.renderTooltipText('Confirm')} onClick={this.handleConfirm.bind(this)}>
            <Icon style={{ color: COLORMAP.teal }}>check</Icon>
          </Tooltip>
        </div>
      );
    } else {
      return (
        <div className={`icon-container ${disabled && 'disabled-icon'}`}>
          <Tooltip placement="top" title={this.renderTooltipText(iconTooltip)}>
            <Icon onClick={this.handleIconClick.bind(this)}>{icon}</Icon>
          </Tooltip>
        </div>
      );
    }
  }

  render() {
    return (
      <div style={{ display: 'inline-block' }}>
        {this.renderIcon()}
      </div>
    );
  }
}

export { ConfirmIcon };


// WEBPACK FOOTER //
// ./src/components/ConfirmIcon.js